import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';

/**
 * Stub Authentication Service for waytr-qr
 * This is a simplified version for QR menu functionality
 * Full authentication is handled by waytr-pos
 */
@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  // eslint-disable-next-line @angular-eslint/prefer-inject
  private readonly router = inject(Router);

  /**
   * Logout - navigates to splash screen
   */
  logout(): void {
    console.warn('Authentication service logout called');
    this.router.navigate(['/splash']);
  }

  /**
   * Stub refresh token method
   * In waytr-qr, tokens are managed by the parent POS system
   */
  refreshToken(params: { refreshToken: string }): Observable<{ accessToken: string; refreshToken: string }> {
    console.warn('Authentication service refreshToken called with:', params);
    // Return empty observable - tokens are managed externally
    return of({ accessToken: '', refreshToken: '' });
  }
}
